'use client';

import React from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import { triggerSquadUpModal } from '@/app/lib/ConditionalLink';
import { formatLink, formatTarget } from '@/app/lib/utils';
import Chevron from '@/app/assets/images/icon_chevron.svg';
import styles from './moreLink.module.scss';

export function MoreLink({ link, slice, text = 'More', mobile = false, extraClass = '', squadupeventid = null, back = false, keepOnMobile = false, showChevron = true }) {
	const href = formatLink(link);
	const hasHash = href.includes('#');

	const handleBuyTicketsClick = (e) => {
		if (squadupeventid) {
			e.preventDefault();
			e.stopPropagation();
			triggerSquadUpModal(squadupeventid);
		}
	};

	return (
		<div className={clsx(styles.more, extraClass, back ? styles.back : '',
			slice?.primary?.more_link_style === 'Fuchsia background with white arrow' ? styles.fuchsia_background :
				slice?.primary?.more_link_style === 'Black background with green arrow' ? styles.black_green :
					slice?.primary?.more_link_style === 'Black background with fuchsia arrow' ? styles.black_fuchsia :
						slice?.primary?.more_link_style === 'White background with fuchsia arrow' ? styles.white_fuchsia :
							slice?.primary?.more_link_style === 'White background with green arrow' ? styles.white_green :
								slice?.primary?.back_link_style === 'Fuchsia background with white arrow' ? styles.fuchsia_background :
									slice?.primary?.back_link_style === 'Black background with green arrow' ? styles.black_green :
										slice?.primary?.back_link_style === 'Black background with fuchsia arrow' ? styles.black_fuchsia :
											slice?.primary?.back_link_style === 'White background with fuchsia arrow' ? styles.white_fuchsia :
												slice?.primary?.back_link_style === 'White background with green arrow' ? styles.white_green :
													styles.fuchsia_background,
			mobile ? styles.mobile_more : '',
			keepOnMobile ? styles.keep_on_mobile : ''
		)}>
			<Link
				href={href}
				scroll={!hasHash}
				className={clsx(styles.link)}
				onClick={(e) => handleBuyTicketsClick(e)}
				target={formatTarget(link)}
				rel={formatTarget(link) === '_blank' ? 'noopener noreferrer' : undefined}
			>
				<div className={clsx(styles.inner, styles.space)}>
					<span>{link?.text || text}</span>
					{showChevron && <Chevron className={styles.chevron} />}
				</div>
				<div className={clsx(styles.inner, styles.initial)}>
					<span>{link?.text || text}</span>
					{showChevron && <Chevron className={styles.chevron} />}
				</div>
				<div className={clsx(styles.inner, styles.second)}>
					<span>{link?.text || text}</span>
					{showChevron && <Chevron className={styles.chevron} />}
				</div>
			</Link>
		</div>
	);
}
